// src/ical/icalSyncApi.ts
import { apiClient } from "@maat/api-base";
var icalSyncApi = {
  // ── Export token ──────────────────────────────────────────────────────
  // Idempotent get-or-create: returns the existing token, or mints one.
  issueToken: async (listingId) => {
    return apiClient.post(`/ical-sync/api/listings/${listingId}/ical-token`);
  },
  // Rotate the token — the old export URL stops working immediately.
  rotateToken: async (listingId) => {
    return apiClient.post(`/ical-sync/api/listings/${listingId}/ical-token/rotate`);
  },
  // ── Import feeds ──────────────────────────────────────────────────────
  listFeeds: async (listingId) => {
    return apiClient.get(`/ical-sync/api/feeds`, { params: { listingId } });
  },
  // The whole workspace's degraded/suspended feeds — the host dashboard's
  // "is my calendar sync broken?" check. Only unhealthy feeds come back, so an
  // empty array means everything is syncing.
  listUnhealthyFeeds: async (limit) => {
    return apiClient.get(`/ical-sync/api/feeds/health`, { params: { limit } });
  },
  // A single feed with its health, for the feed-details page.
  getFeed: async (feedId) => {
    return apiClient.get(`/ical-sync/api/feeds/${feedId}`);
  },
  createFeed: async (data) => {
    return apiClient.post(`/ical-sync/api/feeds`, data);
  },
  // Manually poll a feed now (out of band of the cron). Returns the refreshed feed.
  pollFeed: async (feedId) => {
    return apiClient.post(`/ical-sync/api/feeds/${feedId}/poll`);
  },
  updateFeed: async (feedId, data) => {
    return apiClient.patch(`/ical-sync/api/feeds/${feedId}`, data);
  },
  deleteFeed: async (feedId) => {
    return apiClient.delete(`/ical-sync/api/feeds/${feedId}`);
  },
  // A feed's imported VEVENT snapshot, for the Calendar Sync mini-calendar.
  listFeedBlocks: async (feedId) => {
    return apiClient.get(`/ical-sync/api/feeds/${feedId}/blocks`);
  }
};

export {
  icalSyncApi
};
